import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import './CallMeBackBtn.css';

import { SalesContext } from '../../../Context/SalesContext';
import CellPhoneIcon from '../../Common/Svg/CellPhoneIcon';

import {
  tagOnCallMeBackBtnClicked
}from '../../../Tagging/SalesTagging';

const CallMeBackBtn =({ page }) => {
  const context = useContext(SalesContext);
  const openCallmeBackPopup = () => {
    context.setShowCallMeBack(true);
    tagOnCallMeBackBtnClicked(page);
  }

  return(
    <div className="callmeBack-btn-wrapper">
      <button onClick={() => openCallmeBackPopup()} >
        <span className='callmeBack-btn-icon'>
        <CellPhoneIcon 
          strokeColor='#282828'
          fill= 'black'
          height = '19'
          width = '19'
        />
        </span>
        Call me back
      </button>
    </div>
  );
}

CallMeBackBtn.propTypes = {
  page: PropTypes.string,
};

export default CallMeBackBtn; 